import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { Line } from "react-native-svg";
import { isWeb } from "@madmedical/utils";
import Thresholds from "./Thresholds";
import { coordIdFactory } from "./utils";
import { colors } from "./useStyles";
export default function GraphBar({ graphData = {}, tooltip = {}, }) {
    const { coords = [], randomIdFragment, dashboardThumbnail: { isDashboardThumbnail = false } = {}, } = graphData;
    return (_jsxs(_Fragment, { children: [!isDashboardThumbnail && _jsx(Thresholds, { graphData: graphData }), coords.length > 0 &&
                coords.map(({ x, yLow, yHigh }, i) => {
                    const id = coordIdFactory({
                        randomIdFragment,
                        coord: coords[i],
                    });
                    return (_jsx(Fragment, { children: yLow &&
                            yHigh &&
                            (isWeb ? (_jsx(Line, { stroke: tooltip.onShow && tooltip.id === id
                                    ? colors.blue800
                                    : colors.blue400, strokeLinecap: "round", strokeWidth: "6px", id: id, x1: x, y1: yLow, x2: x, y2: yHigh })) : (_jsx(Line, { scaleY: -1, stroke: tooltip.onShow && tooltip.id === id
                                    ? colors.blue800
                                    : colors.blue400, strokeLinecap: "round", strokeWidth: "6px", id: id, x1: x, y1: yLow, x2: x, y2: yHigh }))) }, id));
                })] }));
}
